
<form #messageForm="ngForm">
    <!--<button class="close-button" mat-icon-button mat-dialog-close cdkFocusInitial>
        <mat-icon aria-label="Close Dialog">close</mat-icon>
    </button>-->

    <ng-container [ngSwitch]="mode">
        <div mat-dialog-content *ngSwitchCase="'prompt'">
            <div *ngIf="data.content" class="_content">
                <div class="{{data.contentClass}}">{{data.content | translate}}</div>
            </div>

            <ng-container [ngSwitch]="data.template">

                <ng-container *ngSwitchCase="'idCard'">
                    <mat-form-field class="w-100" appearance="outline">
                        <mat-label>{{'ID_CARD' | translate}}</mat-label>
                        <input [(ngModel)]="value" name="idCard" matInput type="tel" required pattern="[0-9]*"
                               validIdCard #txtPrompt="ngModel">
                        <!--<mat-error *ngIf="idCard.dirty && idCard.errors?.creditCard">{{idCard.errors.creditCard | translate}}</mat-error>-->
                    </mat-form-field>
                </ng-container>

                <ng-container *ngSwitchDefault>
                    <mat-form-field class="w-100" appearance="outline" *ngIf="!data.numeric">
                        <mat-label>{{data.label  | translate}}</mat-label>
                        <input autocomplete="off" matInput placeholder="{{data.palceholder | translate}}" [(ngModel)]="value" name="value" #txtPrompt="ngModel" required>
                    </mat-form-field>
                    <mat-form-field class="w-100" appearance="outline" *ngIf="data.numeric">
                        <mat-label>{{data.label  | translate}}</mat-label>
                        <input autocomplete="off" matInput placeholder="{{data.palceholder | translate}}" [(ngModel)]="value" name="value" #txtPrompt="ngModel" required type="number" pattern="[0-9]*" inputmode="numeric" [maxlength]="data.maxLength || 4">
                    </mat-form-field>
                </ng-container>

            </ng-container>
        </div>

        <div mat-dialog-content *ngSwitchDefault>
            <div class="text-center" *ngIf="data.animation">
                <lottie-anim [options]="{animation: data.animation, autoplay: true, loop: false}" [height]="200"></lottie-anim>
            </div>
			@if(data.html) {
				<div class="_content-sm {{data.contentClass}}" [innerHTML]="data.html"></div>
			} @else if (data.content) {
				<div class="_content-sm {{data.contentClass}}" style="white-space: pre-wrap;">{{data.content | translate}}</div>
			}

        </div>
    </ng-container>

    <ng-container [ngSwitch]="mode">
        <div mat-dialog-actions *ngSwitchCase="'alert'">
            <button type="button" mat-flat-button color="accent" [mat-dialog-close]="true" class="rounded" style="min-width: 120px;">
                {{(data.confirmText || 'OK') | translate}}
            </button>
        </div>

        <div mat-dialog-actions *ngSwitchCase="'confirm'" [class.lg-buttons]="data.enlargeTextButtons">
            <button type="button" mat-button [mat-dialog-close]="false" class="_cancel">
                {{(data.cancelText || 'Cancel') | translate}}
            </button>
            <button type="button" mat-raised-button color="accent" [mat-dialog-close]="true" class="rounded">
                {{(data.confirmText || 'OK') | translate}}
            </button>
        </div>

        <div mat-dialog-actions *ngSwitchCase="'prompt'">
            <button type="button" mat-button  [mat-dialog-close]="false" class="_cancel">
                {{(data.cancelText || 'Cancel') | translate}}
            </button>
            <button type="button" mat-button color="accent" (click)="confirmPrompt(messageForm)">
                {{(data.confirmText || 'OK') | translate}}
            </button>
        </div>

        <div mat-dialog-actions *ngSwitchCase="'signature'">
            <button type="button" mat-button (click)="clear()" class="_cancel">
                {{'clear' | translate}}
            </button>
            <button type="button" mat-button [mat-dialog-close]="false" class="_cancel">
                {{(data.cancelText || 'Cancel') | translate}}
            </button>
            <button type="button" mat-button color="accent" [mat-dialog-close]="value">
                {{(data.confirmText || 'OK') | translate}}
            </button>
        </div>
    </ng-container>
</form>


